import Text, { TextVariant } from "./Text";

interface props {
  text: string;
  numBoldWords?: number;
  className?: string;
  specificWords?: number[];
  variant?: TextVariant;
}

export default function BoldText({
  text,
  className,
  numBoldWords = 0,
  specificWords = [],
  variant,
}: props) {
  const words = text.split(/\s+/);

  const combinedBoldIndices = new Set([
    ...specificWords,
    ...Array.from({ length: numBoldWords }, (_, i) => i),
  ]);

  return (
    <Text className={className} variant={variant} ariaLabel={text}>
      {words.map((word, index) => {
        const space = index < words.length - 1 ? " " : "";
        return combinedBoldIndices.has(index) ? (
          <span className="font-bold" key={index}>
            {word + space}
          </span>
        ) : (
          word + space
        );
      })}
    </Text>
  );
}
